import React, { Component } from 'react';
import actions from '../actions';
import sharedActions from '../../shared/actions';
import { connect } from 'react-redux';
import meetingRoomActions from '../../../smartBuildings/meetingRooms/actions';
import EntitiesForm from './../components/EntitiesForm';
import Validators from './../../shared/utils/Validators';
import { I18n } from 'react-redux-i18n';
import _ from '../../shared/utils/ObjectUtils';
import { getInitialStateForEntityType, availableEntityTypes, entitiesAllowedParents } from "../../../smartBuildings/otherEntities/utils";
import DateTimeUtils from '../../shared/utils/DateTimeUtils';

class EntitiesFormContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            viewMode: !_.isNilOrEmpty(props.entityId),
            editMode: false,
            createMode: _.isNilOrEmpty(props.entityId),
            alert: {
                show: false
            },
            entityFormData: {
                name: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                type: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                parent: {
                    value: undefined,
                    error: undefined,
                    required: true
                },
                subFormData: {}
            }
        }
    }

    componentDidMount() {
        const { entityId, getEntityData } = this.props;

        if (entityId) {
            getEntityData(entityId);
        }
    };

    componentWillUnmount() {
        this.props.updateCustomTitle();
        this.props.updateCustomBreadcrumbs();
    }

    componentDidUpdate(prevProps, prevState) {
        //Handle Error, Edit and Create
        if (prevProps.loadingCreateRequest && !this.props.loadingCreateRequest) {
            if (this.props.entityWasCreated) {
                this.handleEntityCreateSuccess();
            } else {
                this.handleEntityCreateError(this.props.error)
            }
        } else if (prevProps.loadingDeleteRequest && !this.props.loadingDeleteRequest) {
            if (this.props.entityWasDeleted) {
                this.handleEntityDeleteSuccess();
            } else {
                this.handleEntityDeleteError(this.props.error)
            }
        } else if (prevProps.loadingEditRequest && !this.props.loadingEditRequest) {
            if (this.props.entityWasEdited) {
                this.handleEntityEditSuccess();
            } else {
                this.handleEntityEditError(this.props.error);
            }
        } else if (prevProps.loadingEntity && !this.props.loadingEntity) {
            this.handleEntityLoadingCompleted(this.props.entityData)
        }
    };

    handleEntityLoadingCompleted = entityData => {
        const {
            updateCustomTitle,
            updateCustomBreadcrumbs
        } = this.props;

        updateCustomTitle(entityData.name);
        updateCustomBreadcrumbs([{
            link: "/entities",
            name: I18n.t('routes.entities')
        }, {
            link: "/entities/" + entityData.id,
            name: entityData.name
        }]);

        if (entityData.type === availableEntityTypes.meetingRoom) {
            const { getMeetingRoomProviderList } = this.props;
            getMeetingRoomProviderList();
        }
        this.setState({
            entityFormData: {
                ...this.state.entityFormData,
                ...Object.entries(entityData).reduce(
                    (acc, [key, value]) => {
                        if (this.state.entityFormData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.entityFormData[key],
                                    value: value
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                subFormData: getInitialStateForEntityType(entityData.type, entityData)
            }
        })
    };

    handleFieldChange = (id, value) => {
        if (id === 'type') {
            this.handleEntityTypeChange(value)
        } else {
            this.setState({
                entityFormData: {
                    ...this.state.entityFormData,
                    [id]: {
                        ...this.state.entityFormData[id],
                        value: value
                    }
                }
            }, () => {
                if (_.has(this.state.entityFormData[id], 'required')) {
                    this.validateField(id, false);
                }
            })
        }

    };

    handleImageUploaded = (file, imageUrl) => {
        this.setState({
            entityFormData: {
                ...this.state.entityFormData,
                subFormData: {
                    ...this.state.entityFormData.subFormData,
                    image: {
                        ...this.state.entityFormData.subFormData.image,
                        imagePreview: imageUrl,
                        value: file,
                        error: undefined
                    }
                }
            }
        });
    };

    handleWrongImageFormat = () => {
        this.setState({
            entityFormData: {
                ...this.state.entityFormData,
                subFormData: {
                    ...this.state.entityFormData.subFormData,
                    image: {
                        ...this.state.entityFormData.subFormData.image,
                        imagePreview: undefined,
                        value: undefined,
                        error: I18n.t("entities.errors.image"),
                    }
                }
            }
        });
    };

    handleEntityTypeChange = type => {
        if (type === availableEntityTypes.meetingRoom) {
            const { getMeetingRoomProviderList } = this.props;
            getMeetingRoomProviderList();
        }

        //Reset parent entity value and fetch the possible parents of entity type
        const { getEntityList } = this.props;
        if (type) {
            getEntityList({
                type: entitiesAllowedParents(type)
            });
        }

        this.setState({
            entityFormData: {
                ...this.state.entityFormData,
                type: {
                    ...this.state.entityFormData.type,
                    value: type
                },
                parent: {
                    ...this.state.entityFormData.type,
                    value: undefined
                },
                subFormData: getInitialStateForEntityType(type)
            }
        })
    };

    handleSubFormFieldChange = (id, value) => {
        this.setState({
            entityFormData: {
                ...this.state.entityFormData,
                subFormData: {
                    ...this.state.entityFormData.subFormData,
                    [id]: {
                        ...this.state.entityFormData.subFormData[id],
                        value: value
                    }
                }
            }
        }, () => {
            if (_.has(this.state.entityFormData.subFormData[id], 'required')) {
                this.validateField(id, true);
            }
        })
    };

    validateField = (key, subFormField) => {
        let entityFormDataAux;
        if (subFormField) {
            entityFormDataAux = this.state.entityFormData.subFormData;
        } else {
            entityFormDataAux = this.state.entityFormData;
        }
        let error = null;
        switch (key) {
            case "email":
                error = !Validators.email(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidEmail') : undefined;
                break;
            case "capacity":
            case "maxCapacity":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidCapacity') : undefined;
                break;
            case "latitude":
                error = !Validators.isLatitude(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidLatitude') : undefined;
                break;
            case "longitude":
                error = !Validators.isLongitude(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidLongitude') : undefined;
                break;
            case "websiteLink":
                error = !Validators.isUrl(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidUrl') : undefined;
                break;
            case "logoUrl":
                error = !Validators.isUrl(entityFormDataAux[key].value) ? I18n.t('entities.errors.invalidUrl') : undefined;
                break;
            case "area":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.area') : undefined;
                break;
            case "tolerance":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.tolerance') : undefined;
                break;
            case "checkInTime":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.checkInTime') : undefined;
                break;
            case "daysNumber":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.daysNumber') : undefined;
                break;
            case "hoursNumber":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.hoursNumber') : undefined;
                break;
            case "tolerancePeriod":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.tolerance') : undefined;
                break;
            case "checkInOpen":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.checkInOpen') : undefined;
                break;
            case "calendarDepth":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.calendarDepth') : undefined;
                break;
            case "quickBookPeriod":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.quickBookPeriod') : undefined;
                break;
            case "minimumSchedulingPeriod":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.minimumSchedulingPeriod') : undefined;
                break;
            case "maxMeetingTime":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.maxMeetingTime') : undefined;
                break;
            case "minMeetingTime":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.minMeetingTime') : undefined;
                break;
            case "operationTimeStart":
                const {
                    value: start
                } = entityFormDataAux["operationTimeStart"];

                const {
                    value: end
                } = entityFormDataAux["operationTimeEnd"];

                if (_.isNilOrEmpty(start)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                } else {
                    const [startHours, startMinutes] = start.split(':');
                    if (!_.isNilOrEmpty(end)) {
                        const [endHours, endMinutes] = end.split(':');
                        if (DateTimeUtils
                            .getMomentForTodayWithTime(
                                parseInt(endHours),
                                parseInt(endMinutes), 0, 0
                            )
                            .isBefore(DateTimeUtils
                                .getMomentForTodayWithTime(
                                    parseInt(startHours),
                                    parseInt(startMinutes), 0, 0
                                ))
                        ) {
                            error = I18n.t('entities.errors.operationTimeStartBeforeEnd');
                            entityFormDataAux["operationTimeEnd"].error = undefined;
                        }
                    }
                }
                break;
            case "operationTimeEnd":
                const {
                    value: start2
                } = entityFormDataAux["operationTimeStart"];

                const {
                    value: end2
                } = entityFormDataAux["operationTimeEnd"];

                if (_.isNilOrEmpty(end2)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                } else {
                    const [endHours2, endMinutes2] = end2.split(':');
                    if (!_.isNilOrEmpty(start2)) {
                        const [startHours2, startMinutes2] = start2.split(':');
                        if (DateTimeUtils
                            .getMomentForTodayWithTime(
                                parseInt(endHours2),
                                parseInt(endMinutes2), 0, 0
                            )
                            .isBefore(DateTimeUtils
                                .getMomentForTodayWithTime(
                                    parseInt(startHours2),
                                    parseInt(startMinutes2), 0, 0
                                ))
                        ) {
                            error = I18n.t('entities.errors.operationTimeEndAfterStart');
                            entityFormDataAux["operationTimeStart"].error = undefined;
                        }
                    }
                }
                break;
            case "autoCheckOutDelay":
                error = !Validators.isInteger(entityFormDataAux[key].value) ? I18n.t('entities.errors.autoCheckOutDelay') : undefined;
                break;
            default:
                if (!_.isNilOrEmpty(entityFormDataAux[key].error) &&
                    entityFormDataAux[key].required &&
                    !_.isNilOrEmpty(entityFormDataAux[key].value)) {
                    error = undefined;
                } else if (entityFormDataAux[key].required &&
                    _.isNilOrEmpty(entityFormDataAux[key].value)) {
                    error = I18n.t('forms.errors.emptyRequiredField')
                }
                break;
        }
        if (error !== entityFormDataAux[key].error) {
            entityFormDataAux[key].error = error;
            if (subFormField) {
                this.setState({
                    entityFormData: {
                        ...this.state.entityFormData,
                        subFormData: entityFormDataAux
                    },
                });
            } else {
                this.setState({
                    entityFormData: entityFormDataAux,
                });
            }
        }
    };

    handleOnFieldBlur = (key) => {
        this.validateField(key)
    };

    handleSubmitClick = () => {
        let { editMode, entityFormData } = this.state;
        const { entityId, editEntity, createEntity } = this.props;
        let formHasErrors = false;

        _.forOwn(entityFormData, (field, key) => {
            if (key === 'subFormData') {
                _.forOwn(field, subFormField => {
                    if (subFormField.required && _.isNilOrEmpty(subFormField.value)) {
                        subFormField.error = I18n.t('forms.errors.emptyRequiredField');
                        formHasErrors = true;
                    } else if (!_.isNilOrEmpty(subFormField.error)) {
                        formHasErrors = true;
                    } else {
                        subFormField.error = undefined;
                    }
                });
            } else {
                if (field.required && _.isNilOrEmpty(field.value)) {
                    field.error = I18n.t('forms.errors.emptyRequiredField');
                    formHasErrors = true;
                } else if (!_.isNilOrEmpty(field.error)) {
                    formHasErrors = true;
                } else {
                    field.error = undefined;
                }
            }
        });

        if (!formHasErrors) {
            const formDataToBeSubmitted = Object.entries(entityFormData).reduce((acc, [key, formField]) => {
                if (key === 'subFormData') {
                    const subFormData = Object.entries(formField).reduce((subFormAcc, [subFormKey, subFormField]) => {
                        return {
                            ...subFormAcc,
                            [subFormKey]: subFormField.value
                        }
                    }, {});
                    return {
                        ...acc,
                        ...subFormData
                    }
                }
                return {
                    ...acc,
                    [key]: formField.value
                }
            }, {});

            const entityName = formDataToBeSubmitted.name;
            if (editMode) {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('entities.alerts.edit.title'),
                        html: I18n.t('entities.alerts.edit.text', { entity: entityName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            editEntity(entityId, formDataToBeSubmitted)
                        }
                    }
                })
            } else {
                this.setState({
                    alert: {
                        show: true,
                        type: "warning",
                        title: I18n.t('entities.alerts.create.title'),
                        html: I18n.t('entities.alerts.create.text', { entity: entityName }),
                        confirmButtonText: I18n.t('forms.submit'),
                        cancelButtonText: I18n.t('forms.cancel'),
                        onCancel: this.hideAlert,
                        onConfirm: () => {
                            createEntity(formDataToBeSubmitted)
                        }
                    }
                })
            }
        } else {
            this.setState({
                entityFormData,
            });
        }
    };

    handleEditClick = () => {
        const { editMode, entityFormData } = this.state;
        const { entityData } = this.props;

        if (editMode) {
            this.setState({
                editMode: false,
                viewMode: true,
                entityFormData: {
                    ...Object.entries(entityFormData).reduce((acc, [key, formField]) => {
                        if (entityFormData[key]) {
                            return {
                                ...acc,
                                [key]: {
                                    ...acc[key],
                                    ...this.state.entityFormData[key],
                                    value: entityData[key],
                                    error: undefined
                                }
                            }
                        } else {
                            return acc;
                        }
                    }, {}),
                    subFormData: getInitialStateForEntityType(entityData.type, entityData)
                }
            })
        } else {
            this.setState({
                viewMode: false,
                editMode: true
            })
        }
    };

    hideAlert = () => {
        this.setState({
            alert: {
                show: false
            }
        })
    };

    handleBackClick = () => {
        this.hideAlert();
        this.props.resetEntitiesForm();
        this.props.history.push({
            pathname: '/entities',
            state: { 
                searchFieldsData : this.props.location.state?.searchFieldsData, 
                universalSearchField :  this.props.location.state?.universalSearchField
            }
        });
    };

    handleDeleteClick = () => {
        const { entityId, deleteEntity } = this.props;
        const {
            entityFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: "warning",
                title: I18n.t('entities.alerts.delete.title'),
                html: I18n.t('entities.alerts.delete.text', { entity: name }),
                confirmButtonText: I18n.t('forms.delete'),
                cancelButtonText: I18n.t('forms.cancel'),
                onCancel: this.hideAlert,
                onConfirm: () => {
                    deleteEntity(entityId)
                }
            }
        })
    };

    handleEntityDeleteSuccess = () => {
        const {
            entityFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entities.alerts.delete.success.title'),
                html: I18n.t('entities.alerts.delete.success.text', { entity: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityDeleteError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('entities.alerts.delete.error.title'),
                html: I18n.t('entities.alerts.delete.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleEntityCreateSuccess = () => {
        const {
            entityFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entities.alerts.create.success.title'),
                html: I18n.t('entities.alerts.create.success.text', { entity: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityCreateError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('entities.alerts.create.error.title'),
                html: I18n.t('entities.alerts.create.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    handleEntityEditSuccess = () => {
        const {
            entityFormData: {
                name: {
                    value: name
                }
            }
        } = this.state;

        this.setState({
            alert: {
                show: true,
                type: 'success',
                title: I18n.t('entities.alerts.edit.success.title'),
                html: I18n.t('entities.alerts.edit.success.text', { entity: name }),
                confirmButtonText: I18n.t('forms.ok'),
                onCancel: this.handleBackClick,
                onConfirm: this.handleBackClick
            }
        })
    };

    handleEntityEditError = error => {
        this.setState({
            alert: {
                show: true,
                type: 'error',
                title: I18n.t('entities.alerts.edit.error.title'),
                html: I18n.t('entities.alerts.edit.error.text'),
                confirmButtonText: I18n.t('forms.ok'),
                onConfirm: this.hideAlert
            }
        })
    };

    render() {
        const {
            createMode,
            editMode,
            viewMode,
            entityFormData,
            alert
        } = this.state;
        const {
            entityList,
            providerList,
            loadingDeleteRequest,
            loadingCreateRequest,
            loadingEditRequest,
            entityId,
            history
        } = this.props;

        return <EntitiesForm
            editMode={editMode}
            createMode={createMode}
            viewMode={viewMode}
            alert={{
                ...alert,
                loading: loadingDeleteRequest || loadingCreateRequest || loadingEditRequest
            }}

            entityFormData={entityFormData}
            entityId={entityId}
            history={history}

            entityList={entityFormData.type.value ? entityList : []}
            providerList={providerList}

            handleFieldChange={this.handleFieldChange}
            handleSubFormFieldChange={this.handleSubFormFieldChange}
            handleOnFieldBlur={this.handleOnFieldBlur}
            handleSubmitClick={this.handleSubmitClick}
            handleImageUploaded={this.handleImageUploaded}
            handleWrongImageFormat={this.handleWrongImageFormat}
            handleEditClick={this.handleEditClick}
            handleDeleteClick={this.handleDeleteClick}
            handleBackClick={this.handleBackClick}
        />
    }
}

const mapStateToProps = ({ entitiesReducer, meetingRoomsReducer }) => {
    return {
        entityList: entitiesReducer.entityList,
        providerList: meetingRoomsReducer.providerList,

        entityData: entitiesReducer.entityData,
        loadingEntity: entitiesReducer.loading,
        loadingEntityList: entitiesReducer.loadingListRequest,
        error: entitiesReducer.error,

        loadingDeleteRequest: entitiesReducer.loadingDeleteRequest,
        entityWasDeleted: entitiesReducer.entityWasDeleted,

        loadingCreateRequest: entitiesReducer.loadingCreateRequest,
        entityWasCreated: entitiesReducer.entityWasCreated,

        loadingEditRequest: entitiesReducer.loadingEditRequest,
        entityWasEdited: entitiesReducer.entityWasEdited,
    };
};

const mapDispatchToProps = {
    getEntityData: actions.getEntityData,
    createEntity: actions.createEntity,
    editEntity: actions.editEntity,
    getMeetingRoomProviderList: meetingRoomActions.getMeetingRoomProviderList,
    deleteEntity: actions.deleteEntity,
    resetEntitiesForm: actions.resetEntitiesForm,
    getEntityList: actions.getEntityList,

    updateCustomTitle: sharedActions.updateCustomTitle,
    updateCustomBreadcrumbs: sharedActions.updateCustomBreadcrumbs
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EntitiesFormContainer);